import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const URL_V2 = process.env.REACT_APP_API_V2;

const find = 'process';
const index_view = 'process/index-view';
const create = 'process/create';
const update = 'process/update';
const detail = 'process/detail';
const deleteProcess = 'process/delete';
const hierarchy = 'process/hierarchy';
const treeView = 'process/tree-view';
const moveTree = 'process/move-tree';
const createTree = 'process/add-tree';
const createChild = 'process/create-child';
const importProcess = 'process/import';
const apqcVer = 'process/list-apqc-version';
const apqcLib = 'process/list-apqc-library';
const apqcTemplate = 'process/list-apqc-template';
const createApqc = 'process/add-apqc';
const copyCreate = 'process/add-from-another-board';
const importProcessCopy = 'process/import-from-another-board';
const listProcessLevel = 'process';

export const apiIndexViewBS = async (val) => {
  const datas = await http.post(`${URL + index_view}`, val);
  return datas.data.data;
};
export const apiDetailBS = async (val) => {
  const datas = await http.post(`${URL + detail}`, val);
  return datas.data.data;
};
export const apiCreateBS = async (val) => {
  const datas = await http.post(`${URL + create}`, val);
  return datas.data;
};
export const apiCreateCopyBS = async (val) => {
  const datas = await http.post(`${URL + copyCreate}`, val);
  return datas.data;
};
export const apiUpdateBS = async (val) => {
  const datas = await http.post(`${URL + update}`, val);
  return datas.data;
};
export const apiHierarchy = async (val) => {
  const datas = await http.post(`${URL + hierarchy}`, val);
  return datas.data.data;
};
export const apiTreeView = async (val) => {
  const datas = await http.post(`${URL + treeView}`, val);
  return datas.data.data;
};
export const apiAddTree = async (val) => {
  const datas = await http.post(`${URL + createTree}`, val);
  return datas.data;
};
export const apiCreateChildTree = async (val) => {
  const datas = await http.post(`${URL + createChild}`, val);
  return datas.data;
};
export const apiImportProcess = async (val) => {
  const datas = await http.post(`${URL + importProcess}`, val);
  return datas.data;
};
export const apiImportProcessCopy = async (val) => {
  const datas = await http.post(`${URL + importProcessCopy}`, val);
  return datas.data;
};
export const apiApqcVer = async (val) => {
  const datas = await http.post(`${URL + apqcVer}`, val);
  return datas.data.data;
};
export const apiApqcLib = async (val) => {
  const datas = await http.post(`${URL + apqcLib}`, val);
  return datas.data.data;
};
export const apiApqcTemplate = async (val) => {
  const datas = await http.post(`${URL + apqcTemplate}`, val);
  return datas.data.data;
};
export const apiAddApqc = async (val) => {
  const datas = await http.post(`${URL + createApqc}`, val);
  return datas.data.data;
};
export const apiMoveTree = async (val) => {
  const datas = await http.post(`${URL + moveTree}`, val);
  return datas.data;
};
export const apiDeleteProcess = async (val) => {
  const datas = await http.post(`${URL + deleteProcess}`, val);
  return datas.data;
};
export const apiFindProcess = async (val) => {
  const datas = await http.get(`${URL_V2 + find}`, { params: { ...val } });
  return datas.data;
};
export const apiListProcessLevel = async (val = {}) => {
  const {
    page, page_size: pageSize, level, board_id: boardId,
  } = val;
  let queryParams = '';
  if (val) {
    queryParams = `?page=${page}&page_size=${pageSize}&filter[board_id]=${boardId}&filter[level]=${level}`;
  }
  const datas = await http.get(`${URL_V2 + listProcessLevel + queryParams}`);
  return datas.data.data;
};
